/**
 * Copyright (C) 2020, Merkur India.
 *
 * The program(s) herein may be used and/or copied only with
 * the written permission of Merkur India. or in accordance with
 * the terms and conditions stipulated in the agreement/contract
 * under which the program(s) have been supplied.
 *
 * $Id: BSBellPhase.ts ,v 1.0 Exp $
 * Date Author Changes
 * 3 July 2020 Sujata Nethani Created
 *
 */
namespace WinAnimation.Phase {
    /**
    * BSBellPhase is inherited class of BellPhase.
    * @author <a href=mailto:SNethani@Gauselmann.com>Sujata Nethani</a>
    * $Date: 3 July 2020 $     
    */
    export class BSBellPhase extends TigaBellPhase {
        private loadSpSymbolTimer: Phaser.Timer;
        start(finishCallback: (...args) => any, context?: any, priority?: any, ...args): void {
            this.onComplete.addOnce(finishCallback, context, priority, ...args);
            this.bellSound = this.determineBellSound(this.gameResult, this.response);  
            if (this.bellSoundId === "" || this.bellSoundId === undefined) {
                this.onFinished();
                return;
            }         
            this.bellSoundId = this.bellSound.getSoundIDFor(this.response.lastWagerSum, this.response.getTotalWinAmount());
           
            this.playBellSound(this.bellSoundId);
            let duration = Sounds.SoundManager.getSound(this.bellSoundId).durationMS;
            if (this.loadSpSymbolTimer !== undefined) {
                this.loadSpSymbolTimer.destroy();
                this.loadSpSymbolTimer = null;
            }
            this.loadSpSymbolTimer = Util.Utils.getTimer();
            this.loadSpSymbolTimer.stop();
            this.loadSpSymbolTimer.add(duration, this.onFinished, this);
            this.loadSpSymbolTimer.start();
        }
        
        pause(): void {
            super.pause();
            if (this.winAnimation) {
                for (let winLine of this.winAnimation.winLines) {
                    for (let animation of winLine.animations) {
                        animation.pause();
                    }
                    for (let sprite of winLine.overlays) {
                        sprite.animations.paused = false;
                    }
                }
            }
            if (this.loadSpSymbolTimer) {
                this.loadSpSymbolTimer.pause();
            }            
        }

        resume(): void {
            super.resume();
            if (this.winAnimation) {
                for (let winLine of this.winAnimation.winLines) {
                    for (let animation of winLine.animations) {
                        animation.resume();
                    }
                    for (let sprite of winLine.overlays) {
                        sprite.animations.paused = false;
                    }
                }
            }
            if (this.loadSpSymbolTimer) {
                this.loadSpSymbolTimer.resume();
            }            
        }

        onFinished() {
            if (Sounds.SoundManager.getSound(this.bellSoundId)) {
                Sounds.SoundManager.getSound(this.bellSoundId).stop();
            }
            super.onFinished();
        }
    }
}



